/**
 * Created by mark on 05/03/2018.
 */


import React  from 'react';
import {Form , Row , Col   , Button} from 'react-bootstrap';
import FieldGroup from '../FieldGroup.js';
import validator from 'validator';
import {UserService} from '../../services';
import {UserStore} from '../../store';
import Constants from '../../constants.js';
import Alert from '../alert.js';
import PasswordChange from './password-change.js';
import Translation from '../../store/internationalization-store.js';

export default class PersonalInformation extends React.Component {

    constructor(props) {
        super(props);
        this.state ={
            title:null,
            first_name:"Mark",
            last_name:"Smailes",
            email:"",
            baseEmail:"",
            emailChanged:false,
            duplicateEmail:false,
            loaded:false,
        }

        //isEmail
        //isEmpty
    }


    save(){


        UserService.emailExsit(this.state.email).then(function(exisit){

            if(exisit && this.state.email != this.state.baseEmail){

                this.setState({
                    duplicateEmail:true,
                    saved:false,
                });

                return;
            }

            if(this.validate('title') && this.validate('first_name') && this.validate('last_name') && this.validate('email') && this.validate('phone_number'))
            {
                UserService.updatePersonal({
                    title:this.state.title,
                    first_name:this.state.first_name,
                    last_name:this.state.last_name,
                    email:this.state.email,
                    phone_number:this.state.phone_number,
                    display_name:this.getDisplayOption(this.state.nickname)
                }).then(function(){
                    this.setState({
                        saved:true,
                        baseEmail:this.state.email,
                    });
                }.bind(this))
            }

        }.bind(this));
    }

    componentDidMount(){
        UserService.getPersonal();
    }


    componentWillMount(){

        UserStore.on(Constants.GET_PERSONAL_INFROMATION , ()=>{

            this.setState({
                loaded:true,
                "title": UserStore.getPersonal().title || '',
                "first_name" : UserStore.getPersonal().first_name || '',
                "last_name" : UserStore.getPersonal().last_name || '',
                "email":UserStore.getPersonal().email,
                "baseEmail":UserStore.getPersonal().email,
                "nickname":UserStore.getPersonal().nickname,
                "phone_number":UserStore.getPersonal().phone_number,
            });
        })
    }

    validate(id){

        switch(id)
        {
            case "title": return !validator.isEmpty(String(this.state.title));
            case "first_name": return !validator.isEmpty(String(this.state.first_name));
            case "last_name": return !validator.isEmpty(String(this.state.last_name));
            case "email":

                if(this.state.duplicateEmail) return false;
                else return validator.isEmail(String(this.state.email))

               break;
            case "phone_number": return !validator.isEmpty(String(this.state.phone));
        }

        return true;
    }

    renderPanelHeader(){
        return <div>
            <h1>{Translation.get(12654 , 'Import Students')}</h1>
        </div>
    }


    nameToOption(name){

        if(!isNaN(name)) return name;

        if(this.state.title+' '+this.state.last_name == name)
        {
            return "2";
        }

        if(String(this.state.first_name) == name)
        {
            return "3";
        }

        if(String(this.state.first_name)+' '+this.state.last_name == name)
        {
            return "4";
        }

        return "1";
    }

    getDisplayOption(optionID){

        switch(optionID)
        {
            default: return this.state.title+' '+String(this.state.first_name).charAt(0).toUpperCase()+'. '+this.state.last_name;
            case "2": return this.state.title+' '+this.state.last_name;
            case "3": return String(this.state.first_name);
            case "4": return String(this.state.first_name)+' '+this.state.last_name
        }
    }


    displayOptions(){
        return [
            <option value="1">{this.getDisplayOption()}</option>,
            <option value="2">{this.getDisplayOption("2")}</option>,
            <option value="3">{this.getDisplayOption("3")}</option>,
            <option value="4">{this.getDisplayOption("4")}</option>,
        ]
    }

    render() {

        let saved = null;

        if(!this.state.loaded) return <div style={{minHeight:"400px"}} className="fast animated fadeIn "></div>;
        if(this.state.saved){
            saved = <Alert  variant="success">{Translation.get(12655, 'Your information has been updated')}</Alert>;
        }

        return <div  className="">
                {saved}
                <Row><Col md={6}></Col><Col md={6}><PasswordChange /></Col> </Row>
            <hr/>
                <Row>
                    <Col md={12}>
                        <Row>
                            <Col md={3}>
                                <FieldGroup state={!this.validate('title') ? "invalid" : ""}  onChange={(event)=>{this.setState({saved:false, title:event.target.value})}} value={this.state.title} id="student-name" label={Translation.get(2202 , 'Title')}/>
                            </Col>
                            <Col md={9}>
                                <div className="d-flex flex-column">
                                    <Form.Group  controlId="formGridState">
                                        <Form.Label>{Translation.get(12656 , 'Display Name')}</Form.Label>
                                        <Form.Control as="select" onChange={(event)=>{this.setState({saved:false, nickname:event.target.value})}}  value={this.nameToOption(this.state.nickname)}>
                                            {this.displayOptions()}
                                        </Form.Control>
                                        <small>{Translation.get(12657 , 'This is visible to students')}</small>
                                    </Form.Group>
                                </div>
                            </Col>
                        </Row>
                        <Row>
                            <Col md={6}>
                                <FieldGroup state={!this.validate('first_name') ? "invalid" : ""} help={!this.validate('first_name') ? Translation.get(12782, "This can't be blank") : ""} onChange={(event)=>{this.setState({saved:false, first_name:event.target.value})}} value={this.state.first_name} id="student-name" label={Translation.get(579, 'First Name')}/>
                            </Col>
                            <Col md={6}>
                                <FieldGroup state={!this.validate('last_name') ? "invalid" : ""} help={!this.validate('last_name') ? Translation.get(12782, "This can't be blank") : ""} onChange={(event)=>{this.setState({saved:false, last_name:event.target.value})}} value={this.state.last_name} id="student-name" label={Translation.get(580 , 'Last Name')}/>
                            </Col>
                        </Row>
                        <Row>
                            <Col md={12}>
                                <FieldGroup state={!this.validate('email') ? "invalid" : ""} help={!this.validate('email') ? this.state.duplicateEmail == true ? "Email has been taken" : Translation.get(1033, "Invalid email") : ""} onChange={(event)=>{this.setState({saved:false, duplicateEmail:false , email:event.target.value})}} value={this.state.email} id="student-name" label={Translation.get(9 , 'Email')}/>
                            </Col>
                        </Row>
                        <Row>
                            <Col md={{span:6 , offset:6}}>
                                <Button block onClick={this.save.bind(this)} className="float-right">{Translation.get(12658 , 'Update')}</Button>
                            </Col>
                        </Row>
                    </Col>
                </Row>
        </div>;
    }

}